exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mr-navigation .coupons {\n  display: inline-block;\n  vertical-align: top;\n}\n", ""]);

// exports
